import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@mui/material';
import ComplianceOperationLogic from '.';
import ComplianceOperationTag from '../../../../../../../../../../../../../Common/ComplianceOperationTag/ComplianceOperationTag';
import { AdvancedAnalysisItemType, ComplianceOperationItemFieldsFragment, ComplianceOperationItemScoreRuleOperator } from '../../../../../../../../../../../../../generated/core-api/graphql-react-query';

interface ComplianceOperationAccordionProps {
  advancedAnalysisMap: Map<string, { name: string; type?: AdvancedAnalysisItemType | null }>;
  childrenValue: unknown;
  displayText: string;
  mode?: 'score' | 'weight';
  operationMap?: Map<string, Pick<ComplianceOperationItemFieldsFragment, 'operator' | 'title'>>;
  operator: ComplianceOperationItemScoreRuleOperator;
  topicMap: Map<string, { text: string; color?: string | null }>;
}

export default function ComplianceOperationAccordion(props: ComplianceOperationAccordionProps) {
  const {
    advancedAnalysisMap,
    childrenValue,
    displayText,
    mode,
    operationMap,
    operator,
    topicMap,
  } = props;

  return (
    <Accordion
      disableGutters
      elevation={0}
      square
      className="compliance-operation-accordion"
    >
      <AccordionSummary
        expandIcon={<ExpandMore fontSize="small" />}
        className="compliance-operation-summary"
      >
        <ComplianceOperationTag displayText={displayText} />
      </AccordionSummary>
      <AccordionDetails className="compliance-operation-details">
        <ComplianceOperationLogic
          editable={false}
          mode={mode}
          operator={operator}
          childrenValue={childrenValue}
          topicMap={topicMap}
          advancedAnalysisMap={advancedAnalysisMap}
          operationMap={operationMap}
        />
      </AccordionDetails>
    </Accordion>
  );
}
